import script from "./SimpleBird.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleBird.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleBird.vue?vue&type=style&index=0&id=7f183106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f183106"]])

export default __exports__